(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MyWidget", [], factory);
	else if(typeof exports === 'object')
		exports["MyWidget"] = factory();
	else
		root["MyWidget"] = factory();
})(self, () => {
return 